import uploadsApiClient, {
  UploadFileInput,
  UploadResponse,
} from "../../../api/uploads";
import { UseKlydoMutationOptions } from "../../../components/hooks";
import useUploadMutation from "./useUploadMutation";

const useUploadCollectionLogoMutation = (
  options: Omit<
    UseKlydoMutationOptions<
      UploadResponse,
      UploadFileInput,
      { previousUploadStatus: UploadResponse | undefined }
    >,
    "onSuccess" | "onSettled"
  > & {
    onSuccess?: (response: UploadResponse) => void;
    onSettled?: (response: UploadResponse | undefined, error: unknown) => void;
  } = {},
) => {
  return useUploadMutation(
    uploadsApiClient.uploadCollectionLogo,
    "upload-collection-logo",
    options,
  );
};

export default useUploadCollectionLogoMutation;
